module.exports = __webpack_public_path__ + "img/live_sp.png";